import { Collapse, Divider } from 'antd';
import ButtonIconGhostMedium from '../../../../components/common/ButtonIconGhost/ButtonIconGhostMedium';
import RightMenuDesign from '../../../../components/house/RightMenuDesign/RightMenuDesign';
import { Icon } from '../../../../components/icon/icon';
import './RightPaletteDoorMenu.scss';
import SelectionSupplier from '../SelectionSuplier/SelectionSuplier';
import CardMaterial from '../CardMaterial/CardMaterial';
import RightSupplierMenu from '../RightSupplierMenu/RightSupplierMenu';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchPriceTexture,
  fetchSpecialTextures,
  fetchTextures,
} from '../../../../store/actions/texture.action';
import InfiniteScroll from 'react-infinite-scroll-component';
import { DesignerPageContext } from '../../DesignerPage';
import SwitchComponent from '../../../../components/common/SwitchComponent/SwitchComponent';
import { useTranslation } from 'react-i18next';
import { Popover } from 'antd';
import { InsideType } from '../../../../constants/enum';
import SearchComponent from '../../../../components/common/SearchComponent/SearchComponent';
import { openMessageError } from '../../../../components/common/Message/openMessageError';
import { openMessageWarning } from '../../../../components/common/Message/openMessageWarning';
import {
  checkTextureType,
  getSupplierFromModules,
} from '../../../../utils/modules/ModuleUtils';
import { setCurrentSupplier } from '../../../../store/reducers/supplier.reducer';
import { fetchSuppliers } from '../../../../store/actions/supplier.action';
import ButtonTertiarySmall from '../../../../components/common/ButtonTertiary/ButtonTertiarySmall';
import { TabSpecialTexture } from '../TabSpecialTexture/TabSpecialTexture';

const RightPaletteDoorMenu = ({
  open,
  onClose,
  title,
  canUseAcrylic,
  doorType,
}) => {
  // const [openSupplier, setOpenSupplier] = useState(false);

  // const {
  //   currentSupplier: { frame: supplierId },
  // } = useSelector(state => state.supplier);

  const { renderSupplierMenu, renderContent } = open
    ? RenderContent({ canUseAcrylic, doorType })
    : {};

  return (
    <>
      <RightMenuDesign
        open={open}
        classNames={{ root: 'top-84', content: 'flex flex-col !p-0 gap-0' }}
        header={
          <div className="flex self-stretch items-center justify-start gap-8">
            <ButtonIconGhostMedium
              icon={<Icon.ICArrowBack />}
              onClick={onClose}
            />
            <span className="text-title-large">{title}</span>
          </div>
        }
        content={open ? renderContent?.() : null}
      />
      {renderSupplierMenu?.()}
      {/* <RightSupplierMenu
        open={openSupplier}
        onClose={supplier => {
          setOpenSupplier(false);
          if (!supplier && open) onClose?.();
        }}
        // setSupplierId={setSupplierId}
        // supplierId={supplierId}
        type="door"
      /> */}
    </>
  );
};

export default RightPaletteDoorMenu;

const RenderContent = ({ canUseAcrylic, doorType }) => {
  const { t } = useTranslation();
  const { selectedModels, selectedModel, sceneManager } =
    useContext(DesignerPageContext);
  const [texture, setTexture] = useState();
  const [search, setSearch] = useState();
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [showDulux, setShowDulux] = useState(false);
  const [paintColor, setPaintColor] = useState();
  const { duluxPaletes } = useSelector(state => state.duluxPalete);
  const [supplier, setSupplier] = useState();
  const [textureType, setTextureType] = useState();

  const dispatch = useDispatch();
  const { textures, specialTextures } = useSelector(state => state.texture);
  const {
    suppliers,
    currentSupplier: { door: supplierId },
  } = useSelector(state => state.supplier);

  const { specialTab, setSpecialTab, renderContent, renderSupplierMenu } =
    TabSpecialTexture({
      supplierId,
      supplier,
      setSupplier,
      suppliers,
      textureType,
      // setOpenSupplier,
      type: 'door',
      texture,
      setTexture,
      canUseAcrylic,
    });

  const traverseColorAndTexture = useCallback(
    (selectedModel, canUseAcrylic) => {
      const modules = sceneManager?.cabinetManager?.currentCabinet?.modules;
      if (modules && selectedModel) {
        let supplierIds = { ...supplierId };
        const moduleEntries = Array.from(modules?.entries());
        const module = moduleEntries?.find(
          ([item, value]) => value.group.uuid === selectedModel?.uuid
        );

        // let tempTextureFrame = null;
        // let tempTextureDoor = null;
        // let tempTextureLouveredWall = null;
        // moduleEntries.forEach(([item, value]) => {
        //   if (value?.textures.get('frame')) {
        //     tempTextureFrame = value?.textures.get('frame');
        //   }
        //   if (value?.textures.get('DOOR')) {
        //     tempTextureDoor = value?.textures.get('DOOR');
        //   }
        //   if (
        //     value?.textures.get('VACH-LAM') ||
        //     value?.textures.get('VACH-TRON') ||
        //     value?.textures.get('VACH-GUONG')
        //   ) {
        //     tempTextureLouveredWall =
        //       value?.textures.get('VACH-LAM') ??
        //       value?.textures.get('VACH-TRON') ??
        //       value?.textures.get('VACH-GUONG');
        //   }
        // });

        const currSuppliers = getSupplierFromModules(modules);
        const nonAcrylicSuppliers = currSuppliers.filter(
          s => !['Acrylic'].some(item => s?.materialType?.includes(item))
        );

        const pickedSupplier = canUseAcrylic
          ? currSuppliers[0]
          : nonAcrylicSuppliers[0];

        const supplier = suppliers.data?.[textureType]?.[0];

        if (module) {
          const [item, value] = module;

          const textureDoor = value?.textures.get('DOOR');
          supplierIds = {
            id: textureDoor?.supplier?.id ?? pickedSupplier?.id ?? supplier?.id,
            // tempTextureDoor?.supplier?.id ??
            // tempTextureFrame?.supplier?.id ??
            // tempTextureLouveredWall?.supplier?.id ??
            // supplierId?.id
            materialType:
              textureDoor?.supplier?.materialType ??
              pickedSupplier?.materialType ??
              supplier?.support_types?.[0],
            // tempTextureDoor?.supplier?.materialType ??
            // tempTextureFrame?.supplier?.materialType ??
            // tempTextureLouveredWall?.supplier?.materialType ??
            // supplierId?.
            special:
              textureDoor?.specialTexture ?? pickedSupplier?.special ?? false,
            // tempTextureDoor?.specialTexture ??
            // tempTextureFrame?.specialTexture ??
            // tempTextureLouveredWall?.specialTexture ??
            // textureType?.includes('M'),
          };
          if (supplierIds?.id) {
            dispatch(setCurrentSupplier({ door: supplierIds }));
          }

          if (textureDoor?.textureId) {
            setTexture({
              materialType: textureDoor.supplier?.name ?? '--',
              name: textureDoor.textureCode ?? t('Not selected'),
              src: textureDoor.textureUrl ?? '--',
              textureId: textureDoor.textureId,
              no_grain: textureDoor.no_grain,
              // special: specialTexture
            });
            setPaintColor(textureDoor.paintColor);
            setShowDulux(textureDoor.paintColor ? true : false);
          } else {
            setTexture();
            setPaintColor();
            setShowDulux(false);
          }
        }
      }
    },
    [selectedModel, supplierId, sceneManager, textureType, suppliers]
  );

  const handleClick = useCallback(
    async (item, func, applyToAll) => {
      const materialType =
        specialTab === 'special' ? 'M' : supplierId?.materialType;
      if (item.image) {
        dispatch(
          fetchPriceTexture({
            catalogId: item.id,
            type: materialType,
          })
        ).then(async action => {
          if (action.payload.data) {
            const { data } = action.payload;
            if (!data.some(item => item.thickness === 17)) {
              openMessageWarning({
                content: t(
                  'This texture does not support a thickness of {{x}}mm.',
                  { x: 17 }
                ),
              });
              func();
              return;
            }
            const textureController = sceneManager.textureController;
            const applyTexture = async ({
              module,
              texture = {
                textureId: item.id,
                textureCode: item.code,
                material: materialType,
                texturePrice: {
                  0.017: data.find(item => item.thickness === 17)?.price || 0,
                  0.008: data.find(item => item.thickness === 8)?.price || 0,
                },
                no_grain: item.group_name === 'no_grain',
                url: item.image,
                supplier: {
                  ...(data?.supplier ?? {}),
                  ...(supplierId ?? {}),
                  materialType,
                  name: item.supplier_name,
                  special: specialTab === 'special',
                  ...(item.supplier ?? {}),
                },
                special: specialTab === 'special',
              },
              // excludeMeshes = [],
              includeMeshTypes = [InsideType.DOOR],
            }) => {
              return await textureController.changeTexture({
                module,
                textureType: 'map',
                texture,
                // excludeMeshes,
                includeMeshTypes,
              });
            };

            const modules =
              sceneManager?.cabinetManager?.currentCabinet?.modules;
            const moduleEntries = Array.from(modules?.entries());
            if (applyToAll && selectedModel) {
              const len = moduleEntries?.length;
              if (len) {
                for (let i = 0; i < len; i++) {
                  const [key, value] = moduleEntries[i];
                  let materialType = null;
                  const model = value.group;

                  if (
                    ['lower', 'upper', 'ceiling'].some(
                      item =>
                        model?.userData?.moduleType?.includes(item) &&
                        selectedModel?.userData?.moduleType?.includes(item)
                    )
                  ) {
                    await applyTexture({
                      module: value,
                    });
                  }
                }
              }
            } else {
              const len = selectedModels.length;
              if (len) {
                for (let i = 0; i < len; i++) {
                  const model = selectedModels[i];
                  const [item, value] =
                    moduleEntries?.find(
                      ([item, value]) => value.group.uuid === model.uuid
                    ) ?? [];
                  if (value) {
                    await applyTexture({ module: value });
                  }
                }
              }
            }

            await sceneManager.calculateTotalCost?.({});
            func();
            traverseColorAndTexture(selectedModel, canUseAcrylic);
          }
        });
      } else {
        openMessageError({
          content: t('The texture has no data, please select another texture.'),
        });
      }
    },
    [sceneManager, selectedModel, selectedModels, supplierId, specialTab]
  );

  const loadMoreData = useCallback(async () => {
    const {
      preParams: { offset, limit },
    } = textures;
    try {
      if (supplierId)
        dispatch(
          fetchTextures({
            offset: Number(offset) + Number(limit),
            limit,
            supplier: supplierId.id,
            priceCollectionTypes: supplierId?.materialType,
            kw: debouncedSearch,
          })
        ).then(action => {
          // setLoading(false);
        });
    } catch (e) {
      openMessageError({ content: 'Failed to load texture data.' });
      // setLoading(false);
    }
  }, [supplierId, debouncedSearch, textures]);

  // Debounce searchTerm
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500); // Đợi 500ms sau khi user ngừng gõ

    // Cleanup: Clear timer nếu user gõ tiếp
    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    // loadMoreData();
    if (supplierId && specialTab === 'normal') {
      const {
        preParams: { supplier, priceCollectionTypes, kw },
      } = textures;
      if (
        supplier !== supplierId?.id ||
        supplierId?.materialType !== priceCollectionTypes ||
        kw !== debouncedSearch
      )
        if (supplierId) {
          dispatch(
            fetchTextures({
              offset: 0,
              limit: 20,
              supplier: supplierId?.id,
              priceCollectionTypes: supplierId?.materialType,
              kw:
                debouncedSearch?.trim() === ''
                  ? undefined
                  : debouncedSearch?.trim(),
            })
          );
        }
    }
  }, [debouncedSearch, supplierId, specialTab]);

  useEffect(() => {
    if (selectedModel) {
      traverseColorAndTexture(selectedModel, canUseAcrylic);
      setTextureType(checkTextureType(selectedModels, canUseAcrylic));
    }
  }, [selectedModel, canUseAcrylic]);
  console.log(texture);
  return {
    renderSupplierMenu: renderSupplierMenu,
    renderContent: () => {
      return (
        <>
          <div
            key={1}
            className="flex p-16 flex-col items-start gap-8 self-stretch bg-fills-white"
          >
            {/* <TabSpecialTexture id={"door"} type={"door"} supplier={supplier} setSupplier={setSupplier} supplierId={supplierId} suppliers={suppliers} textureType={textureType} setOpenSupplier={setOpenSupplier} specialTab={specialTab} setSpecialTab={setSpecialTab} /> */}
            {renderContent()}

            <div className="flex justify-between items-center self-stretch">
              <SearchComponent
                size="small"
                style={{ width: '100%' }}
                value={search}
                setValue={setSearch}
              />
            </div>
          </div>
          <Divider type="horizontal" className="m-0 !p-0" />
          {/* {!['Plastic'].includes(supplierId?.materialType) &&
            ['tron', 'kinh'].includes(doorType) &&
            texture?.no_grain && ( */}
          <div
            key={2}
            className="flex px-16 py-8 items-center gap-8 justify-between self-stretch bg-fills-white"
          >
            <span
              className="text-body-medium flex gap-4 items-center"
              style={{ fontWeight: 600 }}
            >
              Sơn màu 2k
              <Popover
                getTooltipContainer={() => document.body}
                placement="bottomLeft"
                classNames={{
                  body: 'py-6 px-12 rounded-[4px]',
                }}
                styles={{
                  body: { maxWidth: '280px' },
                }}
                content={
                  <span
                    className="text-body-medium"
                    style={{ color: '#5A5D60' }}
                  >
                    {t(
                      'You need to select a board color first to use 2K paint. The 2K paint will use the color palette from'
                    )}{' '}
                    <a href="https://www.dulux.vn/vi/mau-sac-bang-mau">Dulux</a>
                  </span>
                }
              >
                <span className="flex w-12 h-12" style={{ color: '#258FD2' }}>
                  <Icon.ICInfoFill />
                </span>
              </Popover>
            </span>

            <SwitchComponent
              value={showDulux}
              disabled={
                // ['Plastic'].includes(supplierId?.materialType) ||
                // !['tron', 'kinh'].includes(doorType) ||
                // &&
                //   ['Plywood'].includes(supplierId?.materialType)
                texture?.no_grain !== true && showDulux === false
              }
              onChange={async () => {
                setShowDulux(prev => {
                  return !prev;
                });
                if (showDulux) {
                  const modules =
                    sceneManager?.cabinetManager?.currentCabinet?.modules;
                  const moduleEntries = Array.from(modules?.entries());
                  const len = selectedModels.length;
                  const textureController = sceneManager.textureController;
                  if (len) {
                    for (let i = 0; i < len; i++) {
                      const model = selectedModels[i];
                      const [item, value] = moduleEntries.find(
                        ([item, value]) => value.group.uuid === model.uuid
                      );
                      await textureController.changeTexture({
                        module: value,
                        textureType: 'color',
                        texture: {},
                        color: undefined,
                        // excludeMeshes: [],
                        includeMeshTypes: [InsideType.DOOR],
                      });
                    }
                  }

                  await sceneManager.calculateTotalCost?.({});
                }
              }}
            />
          </div>
          {/* )} */}

          {showDulux && (
            <div
              key={4}
              className="flex flex-col p-8 items-start gap-16 grow self-stretch overflow-auto"
              style={{ backgroundColor: '#F7F7F7' }}
            >
              <Collapse
                expandIcon={({ isActive }) => (
                  <span className="w-16 h-16 flex">
                    {isActive ? <Icon.ICExpandLess /> : <Icon.ICExpandMore />}
                  </span>
                )}
                onChange={() => {}}
                className="self-stretch overflow-auto"
                rootClassName="!p-0"
                defaultActiveKey={
                  [
                    // ...duluxPaletes?.data?.map((item) => item.hueName),
                  ]
                }
                items={[
                  ...duluxPaletes?.data?.map(item => ({
                    key: item.hueName,
                    label: (
                      <span className="text-title-medium">
                        {t(item.hueName)}
                      </span>
                    ),
                    classNames: {
                      body: '!p-0',
                    },
                    children: (
                      <div className="flex flex-row flex-wrap gap-2">
                        {item.colors?.map(item => {
                          return (
                            <CardMaterial
                              key={item.id}
                              item={{
                                color: item.color?.hex,
                                title: item.color?.title,
                                description: item.color?.hex,
                              }}
                              active={
                                paintColor && item.color?.hex == paintColor
                              }
                              onClick={async (func, applyToAll) => {
                                const textureController =
                                  sceneManager.textureController;
                                const applyTexture = async ({
                                  module,
                                  textureType = 'color',
                                  texture = {},
                                  color = item.color?.hex,
                                  // excludeMeshes = [],
                                  includeMeshTypes = [InsideType.DOOR],
                                }) => {
                                  return await textureController.changeTexture({
                                    module,
                                    textureType,
                                    texture,
                                    // excludeMeshes,
                                    color,
                                    includeMeshTypes,
                                  });
                                };
                                const modules =
                                  sceneManager?.cabinetManager?.currentCabinet
                                    ?.modules;
                                const moduleEntries = Array.from(
                                  modules?.entries()
                                );
                                if (applyToAll && selectedModel) {
                                  const len = moduleEntries?.length;
                                  if (len) {
                                    for (let i = 0; i < len; i++) {
                                      const [key, value] = moduleEntries[i];
                                      const model = value.group;

                                      if (
                                        ['lower', 'upper', 'ceiling'].some(
                                          item =>
                                            model?.userData?.moduleType?.includes(
                                              item
                                            ) &&
                                            selectedModel?.userData?.moduleType?.includes(
                                              item
                                            )
                                        )
                                      )
                                        await applyTexture({
                                          module: value,
                                        });
                                    }
                                  }
                                } else {
                                  const len = selectedModels.length;
                                  if (len) {
                                    for (let i = 0; i < len; i++) {
                                      const model = selectedModels[i];
                                      const [item, value] = moduleEntries.find(
                                        ([item, value]) =>
                                          value.group.uuid === model.uuid
                                      );
                                      await applyTexture({ module: value });
                                    }
                                  }
                                }
                                await sceneManager.calculateTotalCost?.({});

                                func();
                                traverseColorAndTexture(
                                  selectedModel,
                                  canUseAcrylic
                                );
                              }}
                            />
                          );
                        })}
                      </div>
                    ),
                  })),
                ].map(item => ({
                  ...item,
                  onKeyDown: e => {
                    e.stopPropagation();
                  },
                }))}
              />
            </div>
          )}
          {!showDulux && (
            <div
              key={4}
              className="flex flex-col p-8 items-start gap-16 grow self-stretch overflow-auto"
              style={{ backgroundColor: '#F7F7F7' }}
            >
              <div
                id="right-palete-door-menu"
                className="flex flex-col self-stretch grow overflow-scroll"
              >
                {specialTab === 'special' ? (
                  <InfiniteScroll
                    dataLength={specialTextures.data.length}
                    next={loadMoreData}
                    hasMore={
                      specialTextures.data.length < specialTextures.total
                    }
                    scrollableTarget={'right-palete-door-menu'}
                    className="flex flex-row flex-wrap gap-2"
                  >
                    {specialTextures.data.map((item, index) => {
                      return (
                        <CardMaterial
                          key={item.id}
                          item={{
                            title: item.code,
                            description: item.supplier_name,
                            src: item.icon,
                            detailLink: item.detail_link,
                            productDemo: item.product_demo,
                          }}
                          active={texture && item.id === texture.textureId}
                          onClick={async (func, applyToAll) =>
                            await handleClick(item, func, applyToAll)
                          }
                        />
                      );
                    })}
                  </InfiniteScroll>
                ) : null}
                {specialTab === 'normal' ? (
                  <InfiniteScroll
                    dataLength={textures.data.length}
                    next={loadMoreData}
                    hasMore={textures.data.length < textures.total}
                    scrollableTarget={'right-palete-door-menu'}
                    className="flex flex-row flex-wrap gap-2"
                  >
                    {textures.data.map((item, index) => {
                      return (
                        <CardMaterial
                          key={item.id}
                          item={{
                            title: item.code,
                            description:
                              item.price_group_name ?? item.supplier_name,
                            src: item.icon,
                          }}
                          active={texture && item.id === texture.textureId}
                          onClick={async (func, applyToAll) =>
                            await handleClick(item, func, applyToAll)
                          }
                        />
                      );
                    })}
                  </InfiniteScroll>
                ) : null}
              </div>
            </div>
          )}
        </>
      );
    },
  };
};
